<template>
  <div class="chat">
    <CardChatMessages class="card-chat-messages" :messages="messages" />
    <div class="send-message">
      <input class="input-message" type="text" v-model="message" placeholder="Введите сообщение" @keyup.enter="send()" />
      <Button title="Отправить" class="send-btn green" icon="paper-plane" @click="send()" />
    </div>
  </div>
</template>
<script>
import CardChatMessages from "./CardChatMessages.vue";

export default {
  name: "CardChat",
  props: ["card"],
  components: { CardChatMessages },
  computed: {
    messages() {
      if (!this.card) {
        return [];
      }
      return this.card.messages;
    }
  },
  data() {
    return {
      message: ""
    };
  },
  methods: {
    send() {
      if (!this.message) return;

      this.$store.dispatch("cardMessages/new", {
        card: this.card,
        text: this.message
      });

      this.message = "";
    }
  }
};
</script>
<style lang="postcss" scoped>
.chat {
  border: #aeb0b1 1px solid;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  grid-template-areas:
    "send-message"
    "messages";
  height: 100%;

  .card-chat-messages {
    grid-area: messages;
    overflow: auto;
    max-height: 150px;
  }
}

.send-message {
  grid-area: send-message;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: 1fr;
  grid-template-areas: "input-message send-btn";
}

.input-message {
  grid-area: input-message;
  border: 0;
}

.send-btn {
  grid-area: send-btn;
}
</style>
